import { render, staticRenderFns } from "./OTPInput.vue?vue&type=template&id=f7893214&"
import script from "./OTPInput.vue?vue&type=script&lang=js&"
export * from "./OTPInput.vue?vue&type=script&lang=js&"
import style0 from "./OTPInput.vue?vue&type=style&index=0&id=f7893214&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports